import React, { useEffect } from "react";
import styles from "./Print.module.css";

import { useReactToPrint } from "react-to-print";
import Button from "../components/Button";
import { symbol } from "prop-types";
//import { ComponentToPrint } from "../ComponentToPrint";

function PrintEventInvoice({ eventData, serverData }) {
  const componentRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const getTimeValue = (aDate) => {
    if (!aDate) {
      return;
    }
    let theDate = new Date(aDate.slice(0, -1));
    let hours = theDate.getHours();
    let minutes = theDate.getMinutes();

    if (hours != 0) {
      return `${hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours > 12 ? "pm" : "am"}`;
    }
  };

  // const apps = eventData.details.filter((el) => el.Category == "APP" && el.menuItemNotes != null);
  // const ents = eventData.details.filter((el) => el.Category == "ENT" && el.menuItemNotes != null);
  // const dess = eventData.details.filter((el) => el.Category == "DES" && el.menuItemNotes != null);
  // const bevs = eventData.details.filter((el) => el.Category == "BEV" || (el.Category == "BEV-NA" && el.menuItemNotes != null));

  const banquetTotal =
    Number(eventData.fbTotal) +
    Number(eventData.barTotal) +
    Number(eventData.serviceTotal) +
    Number(eventData.otherTotal) +
    Number(eventData.RoomCharge) +
    Number(eventData.addlGrat) -
    Number(eventData.Deposit);

  useEffect(() => {
    reactToPrintFn();
  }, []);

  return (
    <>
      <div className="printOnly">
        <div ref={contentRef} className={styles.fill}>
          <div className={styles.printInvoiceFrame}>
            <div className={`${styles.printSection1of1} ${styles.invoiceHeader} ${styles.pt1} ${styles.mb3}`}>
              <img src="/GVB-WEB__Main-Logo_600.png" alt="" />
              <div className={styles.addressHeader}>
                <h3>INVOICE</h3>
                <br />
                <p>{eventData.street}</p>
                <p>
                  {eventData.city} {eventData.state} {eventData.zip}
                </p>
                <p>{eventData.phone}</p>
              </div>
            </div>
            <div className={`${styles.printSection1of1} ${styles.flexSectionColumn}`}>
              {/* Header Area */}
              <div className={styles.printSection1of1}>
                <h4>EVENT: {eventData.BanquetName}</h4>
              </div>
              <div className={`${styles.printSection1of2}`}>
                <h4>EVENT DATE: {new Date(eventData.BanDate.replace("Z", "")).toDateString()}</h4>
              </div>
              <div className={`${styles.printSection1of2} ${styles.right}`}>
                <h4>ARRIVAL TIME: {getTimeValue(eventData.BanArrivalTime)}</h4>
              </div>

              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={styles.printSection1of3}>
                <div className={styles.contactInfo}>
                  <h5>To:</h5>
                  <p>{eventData.FirstName + " " + eventData.LastName}</p>
                  <p>{eventData.CompanyName}</p>
                  <p>{eventData.Email}</p>
                  <p>{eventData.Phone}</p>
                </div>
                <div className={styles.eventInfo}></div>
                <div className={styles.serverInfo}></div>
              </div>
              <div className={styles.printSection1of3}></div>
              <div className={`${styles.printSection1of3} ${styles.right}`}></div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={`${styles.printSection1of1} ${styles.printContent}`}>
                <div className={styles.printSection1of3}>
                  Guest Count: <b>{eventData.BanAttendance}</b>
                </div>
                <div className={`${styles.printSection1of3} ${styles.right}`}>
                  Banquet Room: <b>{eventData.RoomName}</b>
                </div>
              </div>
              <hr className={`${styles.printSection1of1} ${styles.my1}`} />
              <div className={`${styles.printSection1of1} ${styles.mb3}`}>
                <h4 className={styles.mb1}>Food and Beverage</h4>
                <table className={`${styles.table} ${styles.table_3} ${styles.invoiceTable}`}>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Qty</th>
                      <th className={styles.moneyMiddle}>Price</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(eventData.details) &&
                      eventData.details.map((bd, index) => {
                        if (bd.Category != "ONF")
                          if (bd.isParent) {
                            return (
                              <tr>
                                <td>{bd.item}</td>
                                <td>{bd.isPricePer ? `${bd.qty} (${bd.qty * eventData.BanAttendance}x)` : bd.qty}</td>
                                <td className={styles.moneyMiddle}>
                                  ${bd.isPricePer ? `${Number(bd.Price + bd.addOnPrice).toFixed(2)}/pp` : Number(bd.Price).toFixed(2)}
                                </td>
                                <td>${Number(bd.pricePerTotal).toFixed(2)}</td>
                              </tr>
                            );
                          }
                      })}
                  </tbody>
                </table>
              </div>
              <div className={`${styles.printSection1of1}`}>
                <h4 className={styles.mb1}>Other Charges/Payments</h4>
                <table className={`${styles.table} ${styles.table_3}`}>
                  <thead>
                    <th></th>
                    <th>Qty</th>
                    <th></th>
                    <th>Subtotal</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Room Charge</td>
                      <td></td>
                      <td></td>
                      <td>${Number(eventData.RoomCharge).toFixed(2)}</td>
                    </tr>
                    {Array.isArray(eventData.details) &&
                      eventData.details.map((bd, index) => {
                        if (bd.Category == "ONF")
                          return (
                            <tr>
                              <td>{bd.item}</td>
                              <td>{bd.qty}</td>
                              <td></td>
                              <td>${Number(bd.qty * bd.Price).toFixed(2)}</td>
                            </tr>
                          );
                      })}
                    {eventData.Deposit > 0 && (
                      <tr>
                        <td>Deposit</td>
                        <td></td>
                        <td></td>
                        <td>- ${Number(eventData.Deposit).toFixed(2)}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={`${styles.printSection1of1} ${styles.right} ${styles.flex1} ${styles.breakInside}`}>
              <table className={styles.totalTable}>
                <tbody>
                  <tr>
                    <td>Food and Beverage Total</td>
                    <td>${Number(eventData.fbTotal + eventData.barTotal).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Service Charge</td>
                    <td>${Number(eventData.serviceTotal).toFixed(2)}</td>
                  </tr>
                  {eventData.addlGrat > 0 && (
                    <tr>
                      <td>Additional Gratuity</td>
                      <td>${Number(eventData.addlGrat).toFixed(2)}</td>
                    </tr>
                  )}
                  <tr>
                    <td>Other Charges</td>
                    <td>${Number(eventData.otherTotal).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Room Rental Fee</td>
                    <td>${Number(eventData.RoomCharge).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Less Deposit</td>
                    <td>- ${Number(eventData.Deposit).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Total Due</td>
                    <td>${banquetTotal.toFixed(2)}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="2">
                      <div className={styles.invoiceFooter}>
                        <p>
                          <i>Thank you for choosing Golden Valley!</i>
                        </p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* <Button type="secondary" onClick={() => reactToPrintFn()}>
        Print Event Detail FOH
      </Button> */}
    </>
  );
}

export default PrintEventInvoice;
